export default __webpack_public_path__ + "static/media/icon.antiseptics.a0cb0f61.svg";